<template>
  <h3>Mis gastos de saldo</h3>

  <div class="controlls">
    <a-form class="form" layout="vertical" :model="formState">
      <a-form-item>
        <ChannelIdMultiPicker
          v-model:value="formState.channel_customers"
          :channelType="ChannelType.Whatsapp"
        />
      </a-form-item>

      <a-form-item>
        <!-- TODO: (observaciones beex) Cambiar linea :disabled-date="disabledDateRage && disabledDateRule" por :disabled-date="disabledDateRage" -->
         <a-tooltip title="Puedes seleccionar un rango máximo de 31 días.">
          <a-range-picker
            v-model:value="formState.dateRange"
            format="DD/MM/YYYY"
            valueFormat="YYYY-MM-DD"
            :disabled-date="disabledDateRage"
            @calendarChange="handleCalendarChange"
          />
        </a-tooltip>
        
      </a-form-item>
    </a-form>

    <a-button :loading="downloading" @click="handleDownload"
      >Descargar gastos <DownloadOutlined
    /></a-button>
  </div>

  <a-table
    size="middle"
    id="expenses-table"
    :scroll="scrollStyle"
    :loading="loading"
    :columns="botAIExpensesColumns"
    :dataSource="expensesCurrentPage"
    :pagination="false"
    @change="handleTableChange"
  >
    <template #headerCell="{ title, column }">
      <template v-if="column.type === 'info'">
        {{ title }}

        <a-tooltip :title="column.info">
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
    </template>

    <template #summary>
      <a-table-summary fixed>
        <a-table-summary-row>
          <a-table-summary-cell>Total</a-table-summary-cell>

          <a-table-summary-cell> </a-table-summary-cell>

          <!-- <a-table-summary-cell>
            {{ getTotalByCategory("input_tokens") }}
          </a-table-summary-cell>

          <a-table-summary-cell>
            {{ getTotalByCategory("output_tokens") }}
          </a-table-summary-cell> -->

          <a-table-summary-cell>
            {{ getTotalByCategory("messages_input") }}
          </a-table-summary-cell>

          <a-table-summary-cell>
            {{ getTotalByCategory("messages_output") }}
          </a-table-summary-cell>

          <a-table-summary-cell>
            ${{ getTotalByCategory("fee") }}
          </a-table-summary-cell>
        </a-table-summary-row>
      </a-table-summary>
    </template>
  </a-table>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import { InfoCircleOutlined, DownloadOutlined } from "@ant-design/icons-vue";
import { useIntersectionObserver } from "@vueuse/core";
import _ from "lodash";
import dayjs from "dayjs";

import { botAIExpensesColumns } from "@/app/settings/utils/columns";
import { fetchBotAIExpenses, downloadBotAIExpenses } from "@/app/settings/services";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import { ChannelType } from "@/app/shared/utils/enums";
import { downloadFile } from "@/app/shared/utils/file";
import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";

import ChannelIdMultiPicker from "@/app/shared/components/pickers/ChannelIdMultiPicker.vue";

const { scrollStyle } = useScrollResize({ headerMargin: 525, width: 1800 });

const emit = defineEmits(["loading"]);

const observerFlagRef = ref(null);

// TODO: (observaciones beex) Eliminar (observaciones beex)
const disabledDateRule = (current) => {
  const workspace = localStorage.getItem("workspace");
  if (workspace != "culqi") return current && current < new Date(2024, 7, 1);
  return false;
};

const { pause, resume } = useIntersectionObserver(observerFlagRef, ([{ isIntersecting }]) => {
  console.log({ isIntersecting });
  if (isIntersecting && expensesCurrentPage.value.next) {
    currentTablePage.value++;
    fetchExpensesTableData({ resetFilters: false });
  }
});

const todayDate = dayjs().format("YYYY-MM-DD");

const formState = reactive({
  billing_category: "",
  dateRange: [todayDate, todayDate],
  channel_customers: [],
});
const expensesCurrentPage = ref([]);

const loading = ref(false);
const currentTablePage = ref(1);

const tableSource = ref([]);
// const totalExpenses = ref(null);

const { handleCalendarChange, disabledDateRage } = useDateRangeLimit(30);

const getTotalByCategory = (category) => {
  const totalSum = expensesCurrentPage.value.reduce(
    (prev, curr) => prev + (curr[category] || 0),
    0
  );
  return totalSum ? Number(totalSum.toFixed(4)) : 0;
};

const fetchExpensesTableData = async ({ resetFilters = true } = {}) => {
  if (resetFilters) loading.value = true;
  if (!resetFilters) pause();

  const filters = _.cloneDeep(formState);

  emit('loading', true);
  try {
    const response = await fetchBotAIExpenses({
      filters,
      page: currentTablePage.value,
    });
  }
  finally {
    emit('loading', false);
  }

  // response[0] es un objeto, no un array
  const item = Array.isArray(response) ? response[0] : response;

  let normalized = [];
  if (item && item.bot_totals) {
    normalized = Object.values(item.bot_totals).map((bot) => ({
      customer_name: item.customer_name,
      customer_workspace: item.customer_workspace,
      period_start: item.period.start_time,
      period_end: item.period.end_time,
      ...bot,
    }));
  }

  expensesCurrentPage.value = normalized;
  loading.value = false;
};


// const disabledDate = (current) => {
//   const limit = dayjs("2023-06-30");
//
//   return current && current < limit.endOf("day");
// };

const downloading = ref(false);

const handleDownload = async () => {
  downloading.value = true;

  try {
    const filters = _.cloneDeep(formState);

    const response = await downloadBotAIExpenses({ filters });

    downloadFile(response, "expenses.xlsx", { useResponseFileName: true });
  } catch (error) {
    console.error(error);
  }

  downloading.value = false;
};

watch(
  formState,
  _.debounce(() => {
    currentTablePage.value = 1;
    fetchExpensesTableData();
  }, 500),
  { immediate: true }
);

defineExpose({ fetchExpensesTableData });
</script>

<style lang="sass" scoped>
.controlls
  margin-bottom: 12px
  display: flex
  align-items: center
  justify-content: space-between

.form
  display: flex
  gap: 12px

  .input
    min-width: 160px

:deep(.ant-form-item)
  margin: 0

#expenses-table tfoot th,
#expenses-table tfoot td
  background-color: #fafafa !important
</style>
